import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { ZonedDateTime } from '@js-joda/core';
import { LineItemType, Money } from '../../type/order';
import { Appearance } from '../../type/transcript';
import { Turnaround } from '../transcript-turnaround';
import { LineItem } from './LineItem';
/**
 * A request for a transcript of part of the court record
 */
export class TranscriptLineItem extends LineItem {
    constructor() {
        super(...arguments);
        this.type = LineItemType.CertifiedTranscript;
    }
}
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * The portions of the hearing to transcribe
     */
    )
], TranscriptLineItem.prototype, "estimate", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime
    /**
     * Identifies the job that would be created once the invoice is paid
     */
    )
], TranscriptLineItem.prototype, "dueBy", void 0);
__decorate([
    Type(() => Appearance),
    __metadata("design:type", Object)
], TranscriptLineItem.prototype, "appearances", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime
    /**
     * When the transcript is considered approaching due.
     */
    )
], TranscriptLineItem.prototype, "approachingDue", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime
    /**
     * When the transcript is due by
     */
    )
], TranscriptLineItem.prototype, "transcriptApproachingDue", void 0);
__decorate([
    Serialize(),
    __metadata("design:type", ZonedDateTime
    /**
     * The turnaround the transcript must be delivered in
     */
    )
], TranscriptLineItem.prototype, "transcriptDueBy", void 0);
__decorate([
    Type(() => Turnaround),
    __metadata("design:type", Object)
], TranscriptLineItem.prototype, "turnaround", void 0);
